import { Fragment } from 'react';

import UnitLessonCardList from '@/components/lesson/UnitLessonCardList';
import UnitLessonCard from '@/components/lesson/UnitLessonCard';
import { UnitOverviewCard } from '@/components/unit/UnitOverviewCard';
import useStaffUnitLessons from '@/data/hook/lesson/useStaffUnitLessons';
import { toStaffLessonItems } from '@/utils/lesson/lessonItems';
import { formatLessonName } from '@/utils/lesson/name';
import { CourseRoute } from '@/utils/routes';

type StaffUnitLessonsProps = CourseRoute & {
  unitId: number;
};

export default function StaffUnitLessons({
  unitId,
  slug,
  klassId,
}: StaffUnitLessonsProps) {
  const {
    entries,
    totalLessons,
    isInitialLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useStaffUnitLessons({ unitId, slug, klassId });

  return (
    <Fragment>
      <UnitOverviewCard.LessonsHeader total={totalLessons} />
      <UnitLessonCardList
        isLoading={isInitialLoading}
        isEmpty={!entries.length}
        hasError={!!error}
        onRetry={() => refetch()}
        onReachEnd={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      >
        {entries.map(({ id, lesson, scheduledLesson }) => (
          <UnitLessonCard
            key={id}
            lesson={lesson}
            name={formatLessonName(lesson, scheduledLesson)}
            items={toStaffLessonItems(lesson)}
            slug={slug}
            klassId={klassId}
          />
        ))}
      </UnitLessonCardList>
    </Fragment>
  );
}
